import { Action, ICON_PHONE_OFF_OUTLINE } from '@doveit/bricks';
import React from 'react';
import { getFormattedSeconds } from '../../../utils';
import useTimer, { UseTimerResult } from '../../../hooks/use-timer/useTimer';

export interface CloseCallActionProps extends React.AriaAttributes {
  actionRef: React.MutableRefObject<any>,
  onCallFinished?: VoidFunction
}

const CloseCallAction: React.FC<CloseCallActionProps> = ({
  actionRef,
  onCallFinished,
  'aria-label': ariaLabel = 'Azione di fine chiamata con mobile',
  ...rest
}) => {
  const callTimer = useTimer();

  React.useImperativeHandle(
    actionRef,
    () => (callTimer as UseTimerResult),
    [callTimer],
  );

  return (
    <Action
      {...rest}
      label="Chiamata terminata"
      aria-label={ariaLabel}
      color="critical"
      emphasis="high"
      iconLeft={{ path: ICON_PHONE_OFF_OUTLINE }}
      badgeLabel={getFormattedSeconds(callTimer.seconds)}
      onClick={onCallFinished}
    />
  );
};

export default CloseCallAction;
